export default __webpack_public_path__ + "static/1164-3261f11174e7cbc23bff57ac6818d4de.gif";